import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 4rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  padding: 0;
`;
